import { useAuth0 } from '@auth0/auth0-react';
import { Link, useNavigate } from '@tanstack/react-router';

import { Button } from 'src/shared/components/ui/buttons/button';
import { MFAButton } from 'src/shared/components/ui/buttons/mfa-button';
import { Card, CardFooter } from 'src/shared/components/ui/card';
import { Separator } from 'src/shared/components/ui/separator';
import { useAuth } from 'src/features/auth/contexts/AuthContext';
import { cn } from 'src/shared/lib/utils';

interface EnableMfaProps {
  redirectUrl: string;
  dashboardUrl: string;
  className?: string;
}

export default function EnableMfa({ redirectUrl, dashboardUrl, className }: EnableMfaProps) {
  const { user } = useAuth0();
  const { logout } = useAuth();
  const navigate = useNavigate();

  async function redirectDashboard() {
    navigate({ to: dashboardUrl, replace: true });
  }

  return (
    <div>
      <img src="/static/images/tekst-logo.svg" width={80} height={20} className="mx-auto mb-4" alt="Tekst logo" />
      <Card className={cn('px-7 pt-6 pb-2 space-y-6', className)}>
        <div className=" w-full text-center">
          <p className="text-neutral-400">Enable MFA</p>
        </div>
        <div className="text-center text-neutral-950">
          <p>The organization you are trying to access requires you to enable MFA.</p>
          <Separator className="my-4 w-[50%] mx-auto" />
          <p className="text-neutral-500 text-sm">Use the button below to setup multi factor authentication.</p>
        </div>
        <CardFooter className="flex-center pb-0">
          <div>
            {user?.multifactor ? (
              <Button onClick={redirectDashboard}>Back to dashboard</Button>
            ) : (
              <MFAButton redirectUrl={window.location.origin} />
            )}
            <Link
              to={redirectUrl}
              onClick={logout}
              className="mt-5 flex-center text-neutral-400 text-xs hover:underline"
            >
              Back to login
            </Link>
          </div>
        </CardFooter>
      </Card>
    </div>
  );
}
